import { Redirect, Route, useLocation } from 'react-router-dom'

import { redirecturlQueryParam, siginURL } from '../../app/constants/constants'
import LoadingUpAnimation from '../LoadingUpAnimation'
import { useUpAuth } from './UpAuth'

const PrivateRoute = ({ children, ...rest }: any) => {
  const { isAuthenticated, upAuthLoading } = useUpAuth()
  const { pathname, search } = useLocation();

  if (upAuthLoading) {
    return <LoadingUpAnimation />
  }

  const fullPath = pathname.concat(search);

  const redirectToPath = {
    pathname: siginURL,
    search: `?${redirecturlQueryParam}=${encodeURIComponent(fullPath)}` // should only be added if pathname is different from '/'
  };

  return (
    <Route {...rest}>
      {isAuthenticated ?
        children : <Redirect to={redirectToPath} />
      }
    </Route>
  );
}

export default PrivateRoute
